import React from 'react';
import './TermsConditions.css';

import {MarkdownView} from "../../../components/atoms";
import {TNC_CONTENT_MD} from "./data/contents";

const JournalerTermsConditions = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='pageWrapper'>
      <div className='row justify-content-center'>
        <h1 className='titleBorder text-center'>AEM Algorithm’s ‘Journaler’ terms and conditions</h1>
      </div>
      <div className='container py-4'>
        <MarkdownView>
          {TNC_CONTENT_MD}
        </MarkdownView>
      </div>
    </div>
  );
};

export default JournalerTermsConditions;
